






























import { editName } from '@/main/store/listEditTypes';
import { editFactory } from '@/main/pages/editFactory';

import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	name: editName(NAME),
	methods: {
		async sendReminder() {
			this.startLoading();
			await this.SEND_REMINDERS({ ID: this.ID });
			this.endLoading();
		},
	},
});
